import { t } from '@/features/i18n/utils';
import { BidBreadcrumbs } from '@/features/bids/components/bid-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { ScrollIcon } from '@hugeicons-pro/core-stroke-rounded';
import { Icon } from '@/ui/components/icon';
import { Main } from '@/ui/components/main';
import z from 'zod';
import { getDefaultStore } from 'jotai';
import { chatSidePanelOpenAtom } from '@/features/chat/store';
import { BidDraftPage } from '@/features/bid-draft/components/bid-draft-page';
import { BID_DRAFT_TABS } from '@/features/bid-draft/constants';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/draft',
)({
  staticData: { chatSurface: 'bid_draft' },
  onEnter: () => getDefaultStore().set(chatSidePanelOpenAtom, true),
  component: RouteComponent,
  validateSearch: z.object({
    tab: z.enum(BID_DRAFT_TABS).optional().catch(undefined),
    commentThreadId: z.string().optional(),
    deliverableId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { workspaceId, projectId, bidId } = Route.useParams();

  return (
    <Main>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId/bids/$bidId"
          params={{ projectId, workspaceId, bidId }}
        />
        <BidBreadcrumbs>
          <BreadcrumbPage>
            <Icon icon={ScrollIcon} />
            {t({ en: 'Draft execution plan', nb: 'Utkast til gjennomføringsplan' })}
          </BreadcrumbPage>
        </BidBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <BidDraftPage />
    </Main>
  );
}
